import {all, call, put, takeLeading} from 'redux-saga/effects';
import {actions, ActionType} from './action';
import {getEventPopup, getNoticePopup} from './apiGet';
import {NOTICE_POPUP_KEY} from '../../../common/constant';
import {callApiList} from '../../../common/util/api';
import {getRegionDate} from '../../../common/util/date';
import {makeFetchSaga} from '../../../common/util/fetch';
import {getLocalStorageString} from '../../../common/util/storage';
import {actions as commonSubActions} from '../../../commonSub/state/action';
import {DAYS_TAB_LIST} from '../common';

function* fetchMessages() {
  const {success, data} = yield call(callApiList, [
    {url: '/popup/v1/notice'},
    {url: '/popup/v1/splash'},
  ]);

  if (success && data) {
    const noticePopup = getNoticePopup(data[0]?.notice);
    const eventPopupList = getEventPopup(data[1]?.splash);

    const noticePopupId = getLocalStorageString({
      key: NOTICE_POPUP_KEY,
    });

    /**
     * TODO: https://podotree.atlassian.net/browse/KWQA-14336
     * 일반 공지의 버튼 노출/미노출로 판단하는 게 아닌,
     * 서버의 errorCode가 SERVICE_MAINTENANCE로 내려오고,
     * 동시에 운영 가능한 상태이면 아래 코드는 지운다.
     */
    if (noticePopup?.isMaintenance) {
      yield put(
        commonSubActions.setValue('maintenancePopup', {
          title: noticePopup.title,
          subTitle: noticePopup.date,
          content: noticePopup.content,
        })
      );
    }

    yield put(
      actions.setMessages({
        eventPopupList,
        noticePopup:
          noticePopup?.id !== noticePopupId ? noticePopup : undefined,
      })
    );
  }
}

function* fetchInitializeHome(
  action: ReturnType<typeof actions.fetchInitializeHome>
) {
  const {initialTabPage, initialSecondTab} = action.payload;
  const {weekday} = getRegionDate(Date.now());
  const todayWeekday = [...DAYS_TAB_LIST][(weekday + 6) % 7];

  yield put(
    actions.initializeHome({
      initialTabPage,
      initialSecondTab,
      todayWeekday,
    })
  );
}

export default function* saga() {
  yield all([
    takeLeading(
      ActionType.FetchMessages,
      makeFetchSaga({fetchSaga: fetchMessages, canCache: false})
    ),
    takeLeading(
      ActionType.FetchInitializeHome,
      makeFetchSaga({fetchSaga: fetchInitializeHome, canCache: false})
    ),
  ]);
}
